import { render, staticRenderFns } from "./print.vue?vue&type=template&id=38920022&scoped=true"
import script from "./print.vue?vue&type=script&lang=js"
export * from "./print.vue?vue&type=script&lang=js"
import style0 from "./print.vue?vue&type=style&index=0&id=38920022&prod&lang=css"
import style1 from "./print.vue?vue&type=style&index=1&id=38920022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38920022",
  null
  
)

export default component.exports